import { camelKeys } from 'change-object-case'

export default (props, acceptedProps) =>
  camelKeys(_.pick(props, acceptedProps), { recursive: true })
